import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

import { GenericErrorResponse } from "app/api/types";
import parseError from "app/lib/parseError";
import { BUSHA_ROOT } from "app/constants/routes";
import { retrievePayment } from "app/api/payment";
import { RetrievePaymentPayload } from "app/api/payment/types";
import { AppStateActions, useAppDispatch } from "app/providers/AppStateProvider";

export default function useRetrievePayment(payload: RetrievePaymentPayload) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { isLoading, error, refetch, data } = useQuery(
    ["retrieve-payment", payload],
    () => retrievePayment(payload),
    {
      enabled: Boolean(payload?.id),

      retry: false,
      refetchInterval: 5000, // Poll every 5 seconds regardless of result
      refetchIntervalInBackground: true, // Keep polling even when tab is inactive

      onError: (error: AxiosError<GenericErrorResponse>) => {
        if (error.response?.status === 401) {
          navigate(BUSHA_ROOT, { replace: true });
        }
      },
      onSuccess: (data) => {
        dispatch({
          type: AppStateActions.setPayment,
          payload: data.data.data,
        });
      },
    }
  );

  return {
    isLoading,
    payment: data?.data.data,
    refetch,
    error: error
      ? (parseError(error as AxiosError<GenericErrorResponse>) as string)
      : undefined,
  };
}
